import React from 'react';

import PropTypes from 'prop-types';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import useEntitiesCache from '../hooks/useEntitiesCache';

const EntitiesCacheContext = getOrCreateGlobalContext(
  CONTEXT_NAMES.EntitiesCacheContext,
);

export const useEntitiesCacheContext = () =>
  useContextWithValidation(EntitiesCacheContext, {
    hook: 'useEntitiesCacheContext',
    provider: 'EntitiesCacheProvider',
  });

const EntitiesCacheProvider = React.forwardRef(({ children }, ref) => {
  const contextValue = useEntitiesCache();

  return (
    <EntitiesCacheContext.Provider ref={ref} value={contextValue}>
      {children}
    </EntitiesCacheContext.Provider>
  );
});

EntitiesCacheProvider.displayName = 'EntitiesCacheProvider';

EntitiesCacheProvider.propTypes = {
  /**
   * The content of the provider.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default EntitiesCacheProvider;
